module.exports = __webpack_public_path__ + "img/chevron-down.0aac70f7.svg";